<template>
    <div>
        <div>Błędy... <a href="#" @click.prevent="resetErrors">wyczyść</a></div>

        <ul>
            <li v-for="(error, index) in errors" :key="index">
                {{error.data}}<br/>
                status: {{error.status}}<br/>
                statusText: {{error.statusText}}<br/>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'Errors',
        computed: {
            errors() {
                return this.$store.state.errors
            }
        },
        methods: {
            resetErrors() {
                this.$store.commit('patch', {
                    errors: []
                })
            }
        }
    }
</script>

<style scoped>

</style>